var _ellipse, _rect, _ellipse2, _rect2, _ellipse3, _rect3, _ellipse4, _rect4, _ellipse5, _rect5, _ellipse6, _rect6, _ellipse7, _rect7, _ellipse8, _rect8, _ellipse9, _rect9, _ellipse10, _rect10, _ellipse11, _rect11, _ellipse12, _rect12, _ellipse13, _rect13, _ellipse14, _rect14, _ellipse15, _rect15, _ellipse16, _rect16, _ellipse17, _rect17, _ellipse18, _rect18, _ellipse19, _rect19, _ellipse20, _rect20, _ellipse21, _rect21, _ellipse22, _rect22, _ellipse23, _rect23, _ellipse24, _rect24, _ellipse25, _rect25, _ellipse26, _rect26, _ellipse27, _rect27, _ellipse28, _rect28, _ellipse29, _rect29, _ellipse30, _rect30, _ellipse31, _rect31, _ellipse32, _rect32, _ellipse33, _rect33, _ellipse34, _rect34, _ellipse35, _rect35, _ellipse36, _rect36, _ellipse37, _rect37, _ellipse38, _rect38, _ellipse39, _rect39, _ellipse40, _rect40, _ellipse41, _rect41, _ellipse42, _rect42, _ellipse43, _rect43, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 399,
    height: 424,
    viewBox: "0 0 399 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 27.0212,
    ry: 27.0179,
    transform: "matrix(0.999106 0.0148928 0.0398542 -0.998542 124.074 396.381)",
    fill: "url(#paint0_linear_10797_37559)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.0742,
    height: 30.4526,
    transform: "matrix(0.9991 0.0149811 0.0397768 -0.998541 106 412.365)",
    fill: "url(#pattern0)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 16.6562,
    ry: 16.6542,
    transform: "matrix(-0.968917 0.244202 0.219946 0.974833 238.083 20.781)",
    fill: "url(#paint1_linear_10797_37559)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 23.4694,
    height: 18.7713,
    transform: "matrix(-0.968934 0.244116 0.22002 0.974812 246.293 8.38086)",
    fill: "url(#pattern1)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 16.6562,
    ry: 16.6542,
    transform: "matrix(0.690183 -0.722553 -0.705169 -0.708104 238.142 301.165)",
    fill: "url(#paint2_linear_10797_37559)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 23.4694,
    height: 18.7713,
    transform: "matrix(0.690243 -0.722489 -0.705221 -0.708047 237.793 316.032)",
    fill: "url(#pattern2)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 16.6562,
    ry: 16.6542,
    transform: "matrix(0.690183 -0.722553 -0.705169 -0.708104 269.142 101.165)",
    fill: "url(#paint3_linear_10797_37559)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 23.4694,
    height: 18.7713,
    transform: "matrix(0.690243 -0.722489 -0.705221 -0.708047 268.793 116.032)",
    fill: "url(#pattern3)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 16.6562,
    ry: 16.6542,
    transform: "matrix(0.690183 -0.722553 -0.705169 -0.708104 115.142 271.165)",
    fill: "url(#paint4_linear_10797_37559)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 23.4694,
    height: 18.7713,
    transform: "matrix(0.690243 -0.722489 -0.705221 -0.708047 114.793 286.032)",
    fill: "url(#pattern4)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.85897,
    ry: 4.85839,
    transform: "matrix(0.690183 -0.722553 -0.705169 -0.708104 124.045 199.05)",
    fill: "url(#paint5_linear_10797_37559)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 6.84655,
    height: 5.47601,
    transform: "matrix(0.690243 -0.722489 -0.705221 -0.708047 123.941 203.387)",
    fill: "url(#pattern5)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.85897,
    ry: 4.85839,
    transform: "matrix(0.690183 -0.722553 -0.705169 -0.708104 134.045 136.05)",
    fill: "url(#paint6_linear_10797_37559)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 6.84655,
    height: 5.47601,
    transform: "matrix(0.690243 -0.722489 -0.705221 -0.708047 133.941 140.387)",
    fill: "url(#pattern6)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.85897,
    ry: 4.85839,
    transform: "matrix(0.690183 -0.722553 -0.705169 -0.708104 185.045 64.0499)",
    fill: "url(#paint7_linear_10797_37559)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 6.84655,
    height: 5.47601,
    transform: "matrix(0.690243 -0.722489 -0.705221 -0.708047 184.941 68.3867)",
    fill: "url(#pattern7)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.85897,
    ry: 4.85839,
    transform: "matrix(0.690183 -0.722553 -0.705169 -0.708104 77.0448 89.0499)",
    fill: "url(#paint8_linear_10797_37559)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 6.84655,
    height: 5.47601,
    transform: "matrix(0.690243 -0.722489 -0.705221 -0.708047 76.9414 93.3867)",
    fill: "url(#pattern8)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.85897,
    ry: 4.85839,
    transform: "matrix(0.690183 -0.722553 -0.705169 -0.708104 212.045 129.05)",
    fill: "url(#paint9_linear_10797_37559)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 6.84655,
    height: 5.47601,
    transform: "matrix(0.690243 -0.722489 -0.705221 -0.708047 211.941 133.387)",
    fill: "url(#pattern9)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.85897,
    ry: 4.85839,
    transform: "matrix(0.690183 -0.722553 -0.705169 -0.708104 336.045 158.05)",
    fill: "url(#paint10_linear_10797_37559)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 6.84655,
    height: 5.47601,
    transform: "matrix(0.690243 -0.722489 -0.705221 -0.708047 335.941 162.387)",
    fill: "url(#pattern10)"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.85897,
    ry: 4.85839,
    transform: "matrix(0.690183 -0.722553 -0.705169 -0.708104 309.045 71.0499)",
    fill: "url(#paint11_linear_10797_37559)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 6.84655,
    height: 5.47601,
    transform: "matrix(0.690243 -0.722489 -0.705221 -0.708047 308.941 75.3867)",
    fill: "url(#pattern11)"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.85897,
    ry: 4.85839,
    transform: "matrix(0.690183 -0.722553 -0.705169 -0.708104 302.045 344.05)",
    fill: "url(#paint12_linear_10797_37559)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 6.84655,
    height: 5.47601,
    transform: "matrix(0.690243 -0.722489 -0.705221 -0.708047 301.941 348.387)",
    fill: "url(#pattern12)"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.85897,
    ry: 4.85839,
    transform: "matrix(0.690183 -0.722553 -0.705169 -0.708104 183.045 254.05)",
    fill: "url(#paint13_linear_10797_37559)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 6.84655,
    height: 5.47601,
    transform: "matrix(0.690243 -0.722489 -0.705221 -0.708047 182.941 258.387)",
    fill: "url(#pattern13)"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.85897,
    ry: 4.85839,
    transform: "matrix(0.690183 -0.722553 -0.705169 -0.708104 270.045 208.05)",
    fill: "url(#paint14_linear_10797_37559)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 6.84655,
    height: 5.47601,
    transform: "matrix(0.690243 -0.722489 -0.705221 -0.708047 269.941 212.387)",
    fill: "url(#pattern14)"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.71851,
    ry: 8.71746,
    transform: "matrix(0.687327 0.72527 0.742305 -0.669073 43.6354 257.745)",
    fill: "url(#paint15_linear_10797_37559)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2848,
    height: 9.82567,
    transform: "matrix(0.687259 0.725327 0.74225 -0.669128 35.8711 257.175)",
    fill: "url(#pattern15)"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.71851,
    ry: 8.71746,
    transform: "matrix(-0.320808 0.946318 0.93812 0.344392 109.186 45.3328)",
    fill: "url(#paint16_linear_10797_37559)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2848,
    height: 9.82567,
    transform: "matrix(-0.32089 0.946285 0.938143 0.344318 106.07 38.2002)",
    fill: "url(#pattern16)"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.71851,
    ry: 8.71746,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 361.331 102.257)",
    fill: "url(#paint17_linear_10797_37559)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2848,
    height: 9.82567,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 368.992 100.886)",
    fill: "url(#pattern17)"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.71851,
    ry: 8.71746,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 222.331 177.257)",
    fill: "url(#paint18_linear_10797_37559)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2848,
    height: 9.82567,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 229.992 175.886)",
    fill: "url(#pattern18)"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.93442,
    ry: 2.93407,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 83.1489 120.125)",
    fill: "url(#paint19_linear_10797_37559)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 4.13476,
    height: 3.30706,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 85.7266 119.664)",
    fill: "url(#pattern19)"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.93442,
    ry: 2.93407,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 86.1489 216.125)",
    fill: "url(#paint20_linear_10797_37559)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 4.13476,
    height: 3.30706,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 88.7266 215.664)",
    fill: "url(#pattern20)"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.93442,
    ry: 2.93407,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 185.149 96.1253)",
    fill: "url(#paint21_linear_10797_37559)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 4.13476,
    height: 3.30706,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 187.727 95.6641)",
    fill: "url(#pattern21)"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.93442,
    ry: 2.93407,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 181.149 173.125)",
    fill: "url(#paint22_linear_10797_37559)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 4.13476,
    height: 3.30706,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 183.727 172.664)",
    fill: "url(#pattern22)"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.93442,
    ry: 2.93407,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 55.1489 317.125)",
    fill: "url(#paint23_linear_10797_37559)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 4.13476,
    height: 3.30706,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 57.7266 316.664)",
    fill: "url(#pattern23)"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.93442,
    ry: 2.93407,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 4.14888 211.125)",
    fill: "url(#paint24_linear_10797_37559)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 4.13476,
    height: 3.30706,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 6.72656 210.664)",
    fill: "url(#pattern24)"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.93442,
    ry: 2.93407,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 226.149 206.125)",
    fill: "url(#paint25_linear_10797_37559)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 4.13476,
    height: 3.30706,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 228.727 205.664)",
    fill: "url(#pattern25)"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.93442,
    ry: 2.93407,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 328.149 90.1253)",
    fill: "url(#paint26_linear_10797_37559)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 4.13476,
    height: 3.30706,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 330.727 89.6641)",
    fill: "url(#pattern26)"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.93442,
    ry: 2.93407,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 379.149 171.125)",
    fill: "url(#paint27_linear_10797_37559)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 4.13476,
    height: 3.30706,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 381.727 170.664)",
    fill: "url(#pattern27)"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.93442,
    ry: 2.93407,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 336.149 325.125)",
    fill: "url(#paint28_linear_10797_37559)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 4.13476,
    height: 3.30706,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 338.727 324.664)",
    fill: "url(#pattern28)"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.93442,
    ry: 2.93407,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 237.149 381.125)",
    fill: "url(#paint29_linear_10797_37559)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 4.13476,
    height: 3.30706,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 239.727 380.664)",
    fill: "url(#pattern29)"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.93442,
    ry: 2.93407,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 140.149 324.125)",
    fill: "url(#paint30_linear_10797_37559)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 4.13476,
    height: 3.30706,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 142.727 323.664)",
    fill: "url(#pattern30)"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.4527,
    ry: 1.45252,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 198.616 289.043)",
    fill: "url(#paint31_linear_10797_37559)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 2.04693,
    height: 1.63718,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 199.895 288.814)",
    fill: "url(#pattern31)"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.4527,
    ry: 1.45252,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 108.054 236.043)",
    fill: "url(#paint32_linear_10797_37559)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 2.04693,
    height: 1.63718,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 109.332 235.814)",
    fill: "url(#pattern32)"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.4527,
    ry: 1.45252,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 94.0537 156.043)",
    fill: "url(#paint33_linear_10797_37559)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 2.04693,
    height: 1.63718,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 95.332 155.814)",
    fill: "url(#pattern33)"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.4527,
    ry: 1.45252,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 290.054 155.043)",
    fill: "url(#paint34_linear_10797_37559)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 2.04693,
    height: 1.63718,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 291.332 154.814)",
    fill: "url(#pattern34)"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.4527,
    ry: 1.45252,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 214.054 79.0427)",
    fill: "url(#paint35_linear_10797_37559)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 2.04693,
    height: 1.63718,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 215.332 78.8145)",
    fill: "url(#pattern35)"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.4527,
    ry: 1.45252,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 276.054 63.0427)",
    fill: "url(#paint36_linear_10797_37559)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 2.04693,
    height: 1.63718,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 277.332 62.8145)",
    fill: "url(#pattern36)"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.4527,
    ry: 1.45252,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 313.054 289.043)",
    fill: "url(#paint37_linear_10797_37559)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 2.04693,
    height: 1.63718,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 314.332 288.814)",
    fill: "url(#pattern37)"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.4527,
    ry: 1.45252,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 109.054 339.043)",
    fill: "url(#paint38_linear_10797_37559)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 2.04693,
    height: 1.63718,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 110.332 338.814)",
    fill: "url(#pattern38)"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.4527,
    ry: 1.45252,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 249.054 177.043)",
    fill: "url(#paint39_linear_10797_37559)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 2.04693,
    height: 1.63718,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 250.332 176.814)",
    fill: "url(#pattern39)"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.71851,
    ry: 8.71746,
    transform: "matrix(-0.84558 -0.532381 -0.553407 0.832116 191.331 352.257)",
    fill: "url(#paint40_linear_10797_37559)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2848,
    height: 9.82567,
    transform: "matrix(-0.845529 -0.532453 -0.55334 0.832155 198.992 350.886)",
    fill: "url(#pattern40)"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 33.7948,
    ry: 33.7907,
    transform: "matrix(0.21767 -0.97522 -0.969594 -0.241996 357.667 256.339)",
    fill: "url(#paint41_linear_10797_37559)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 47.6186,
    height: 38.0864,
    transform: "matrix(0.217755 -0.975196 -0.969609 -0.24192 372.645 282.532)",
    fill: "url(#pattern41)"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 25.077,
    ry: 25.0739,
    transform: "matrix(0.486655 0.872698 0.88469 -0.464756 45.031 156.268)",
    fill: "url(#paint42_linear_10797_37559)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 35.3348,
    height: 28.2615,
    transform: "matrix(0.486576 0.872737 0.884651 -0.464823 23.8008 149.16)",
    fill: "url(#pattern42)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern7",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern8",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern9",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern10",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern11",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern12",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern13",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern14",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern15",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern16",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern17",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern18",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern19",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern20",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern21",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern22",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern23",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern24",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern25",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern26",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern27",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern28",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern29",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern30",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern31",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern32",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern33",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern34",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern35",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern36",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern37",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern38",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern39",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern40",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern41",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern42",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10797_37559",
    transform: "scale(0.003125 0.00371747)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10797_37559",
    x1: 27.0212,
    y1: 0,
    x2: 27.0212,
    y2: 54.0358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10797_37559",
    x1: 16.6562,
    y1: 0,
    x2: 16.6562,
    y2: 33.3084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10797_37559",
    x1: 16.6562,
    y1: 0,
    x2: 16.6562,
    y2: 33.3084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10797_37559",
    x1: 16.6562,
    y1: 0,
    x2: 16.6562,
    y2: 33.3084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10797_37559",
    x1: 16.6562,
    y1: 0,
    x2: 16.6562,
    y2: 33.3084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10797_37559",
    x1: 4.85897,
    y1: 0,
    x2: 4.85897,
    y2: 9.71678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10797_37559",
    x1: 4.85897,
    y1: 0,
    x2: 4.85897,
    y2: 9.71678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10797_37559",
    x1: 4.85897,
    y1: 0,
    x2: 4.85897,
    y2: 9.71678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10797_37559",
    x1: 4.85897,
    y1: 0,
    x2: 4.85897,
    y2: 9.71678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10797_37559",
    x1: 4.85897,
    y1: 0,
    x2: 4.85897,
    y2: 9.71678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10797_37559",
    x1: 4.85897,
    y1: 0,
    x2: 4.85897,
    y2: 9.71678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10797_37559",
    x1: 4.85897,
    y1: 0,
    x2: 4.85897,
    y2: 9.71678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10797_37559",
    x1: 4.85897,
    y1: 0,
    x2: 4.85897,
    y2: 9.71678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10797_37559",
    x1: 4.85897,
    y1: 0,
    x2: 4.85897,
    y2: 9.71678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10797_37559",
    x1: 4.85897,
    y1: 0,
    x2: 4.85897,
    y2: 9.71678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10797_37559",
    x1: 8.71851,
    y1: 0,
    x2: 8.71851,
    y2: 17.4349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10797_37559",
    x1: 8.71851,
    y1: 0,
    x2: 8.71851,
    y2: 17.4349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10797_37559",
    x1: 8.71851,
    y1: 0,
    x2: 8.71851,
    y2: 17.4349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10797_37559",
    x1: 8.71851,
    y1: 0,
    x2: 8.71851,
    y2: 17.4349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10797_37559",
    x1: 2.93442,
    y1: 0,
    x2: 2.93442,
    y2: 5.86814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10797_37559",
    x1: 2.93442,
    y1: 0,
    x2: 2.93442,
    y2: 5.86814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10797_37559",
    x1: 2.93442,
    y1: 0,
    x2: 2.93442,
    y2: 5.86814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10797_37559",
    x1: 2.93442,
    y1: 0,
    x2: 2.93442,
    y2: 5.86814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10797_37559",
    x1: 2.93442,
    y1: 0,
    x2: 2.93442,
    y2: 5.86814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10797_37559",
    x1: 2.93442,
    y1: 0,
    x2: 2.93442,
    y2: 5.86814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10797_37559",
    x1: 2.93442,
    y1: 0,
    x2: 2.93442,
    y2: 5.86814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10797_37559",
    x1: 2.93442,
    y1: 0,
    x2: 2.93442,
    y2: 5.86814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10797_37559",
    x1: 2.93442,
    y1: 0,
    x2: 2.93442,
    y2: 5.86814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10797_37559",
    x1: 2.93442,
    y1: 0,
    x2: 2.93442,
    y2: 5.86814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10797_37559",
    x1: 2.93442,
    y1: 0,
    x2: 2.93442,
    y2: 5.86814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10797_37559",
    x1: 2.93442,
    y1: 0,
    x2: 2.93442,
    y2: 5.86814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10797_37559",
    x1: 1.4527,
    y1: 0,
    x2: 1.4527,
    y2: 2.90505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10797_37559",
    x1: 1.4527,
    y1: 0,
    x2: 1.4527,
    y2: 2.90505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10797_37559",
    x1: 1.4527,
    y1: 0,
    x2: 1.4527,
    y2: 2.90505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10797_37559",
    x1: 1.4527,
    y1: 0,
    x2: 1.4527,
    y2: 2.90505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10797_37559",
    x1: 1.4527,
    y1: 0,
    x2: 1.4527,
    y2: 2.90505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10797_37559",
    x1: 1.4527,
    y1: 0,
    x2: 1.4527,
    y2: 2.90505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10797_37559",
    x1: 1.4527,
    y1: 0,
    x2: 1.4527,
    y2: 2.90505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10797_37559",
    x1: 1.4527,
    y1: 0,
    x2: 1.4527,
    y2: 2.90505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10797_37559",
    x1: 1.4527,
    y1: 0,
    x2: 1.4527,
    y2: 2.90505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_10797_37559",
    x1: 8.71851,
    y1: 0,
    x2: 8.71851,
    y2: 17.4349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_10797_37559",
    x1: 33.7948,
    y1: 0,
    x2: 33.7948,
    y2: 67.5814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_10797_37559",
    x1: 25.077,
    y1: 0,
    x2: 25.077,
    y2: 50.1479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7C03"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10797_37559",
    width: 320,
    height: 269,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.48d83f011f7218b91615d6f07219b81e.svg";
export { ForwardRef as ReactComponent };